import React from 'react';
import { footerLinks } from '../data/content';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-ink-900 px-4 py-9 sm:px-6 sm:py-12" data-id="element-68" data-mp="3geze367ujv27">
      <div className="mx-auto max-w-2xl text-center" data-id="element-69" data-mp="32o4b2ak1486j">
        <p className="text-xl font-extrabold uppercase tracking-[0.18em] text-gold-500 sm:text-2xl" data-id="element-70" data-mp="32pfc42m3b1ty">
          🏆 VALUX™
        </p>

        <p className="mt-3 text-[13px] text-neutral-300 sm:text-sm" data-id="element-71" data-mp="3uf0opddwyguv">
          El sistema de herramientas N°1 para el comerciante argentino.
        </p>
        <p className="mt-1.5 text-[13px] italic text-neutral-400 sm:text-sm" data-id="element-72" data-mp="37fvf8oqf24t">
          "Porque vender más no debería depender de la suerte."
        </p>

        <ul className="mt-6 space-y-2 text-[13px]" data-id="element-73" data-mp="3qd6qdbr6xoxv">
          {footerLinks.map(link => <li key={link.label} data-id="element-74" data-mp="29z6woiixuvj2">
              <a href={link.href} target={link.href.startsWith('http') ? '_blank' : undefined} rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined} className="inline-flex items-center gap-2 text-neutral-300 transition-colors duration-150 hover:text-gold-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400" data-id="element-75" data-mp="29y5g5yj5lgty">
                <span aria-hidden="true" className="text-xs" data-id="element-76" data-mp="3q7llpovzp6kj">
                  {link.icon}
                </span>
                {link.label}
              </a>
            </li>)}
        </ul>

        <p className="mx-auto mt-7 max-w-lg border-t border-white/10 pt-5 text-[11px] leading-relaxed text-neutral-600" data-id="element-77" data-mp="335szh7bvjgh">
          © 2026 VALUX™ — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </p>

        <p className="mt-5 text-[13px] font-semibold italic text-gold-400" data-id="element-78" data-mp="qt049uc00zym">
          🔨 "El próximo clavo que saques puede pagar este sistema entero."
        </p>
      </div>
    </footer>;
}